import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { HelpCircle } from 'lucide-react';

const faqs = [
  {
    question: "What payment methods do you accept?",
    answer: "We accept Visa, Mastercard, and other major credit and debit cards. All payments are processed securely through our encrypted gateway.",
  },
  {
    question: "How long does delivery take?",
    answer: "Standard delivery takes 5–10 business days. After your order ships, you'll receive a tracking number via email.",
  },
  {
    question: "What is your return policy?",
    answer: "We offer a 30-day return policy for unused items in original packaging. Simply contact our support team to initiate a return.",
  },
  {
    question: "Do products come with a warranty?",
    answer: "Yes, all products come with a manufacturer's warranty. The warranty period varies by product and is listed on each product page.",
  },
  {
    question: "How can I track my order?",
    answer: "After placing your order, you'll receive a confirmation email with a tracking link. You can also contact our support team for order status updates.",
  },
  {
    question: "Do you ship internationally?",
    answer: "Yes, we ship worldwide. Shipping times and costs vary by destination. Check our shipping page for details.",
  },
];

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
};

export const HomeFAQ: React.FC = () => {
  return (
    <section className="container-wide py-12 md:py-16">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-2 mb-8">
          <HelpCircle className="h-6 w-6 text-primary" />
          <h2 className="text-2xl md:text-3xl font-bold">Frequently Asked Questions</h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger className="text-left text-base font-medium">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};